export default {
	"exchange.GetTheVerificationCode": "Get the verification code",
	"exchange.Resend": "Resend",
	"exchange.PleaseEnterYourPhoneNumber": "Please enter your phone number",
	"exchange.PleaseEnterTheCorrectMobilePhoneNumber": "Please enter the correct mobile phone number",
	"exchange.please": "please",
	"exchange.sResendAfterThat": "s resend after that",
	"exchange.FailedToGetVerificationCode": "Failed to get verification code",
	"exchange.TheVerificationCodeIsNotLegitimate": "The verification code is not legitimate",
	"exchange.TheVerificationCodeIsIncorrect": "The verification code is incorrect",
	"exchange.ThereAreNoRedeemableItemsForThisMobilePhoneNumber": "There are no redeemable items for this mobile phone number",
	"exchange.VerificationCode": "Verification code",
	"exchange.RedeemNow": "Redeem now",
	"exchange.SelectRedeemProducts": "Select Redeem products"
}